import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDefaultValueChange]'
})
export class DefaultValueChangeDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target.value']) onInput(value: any) {
    // Emit the value change to the service
    const textareaElement = this.el.nativeElement.querySelector('.angular-editor-textarea');
    if (textareaElement) {
      const firstChild = textareaElement.firstChild;
      if (firstChild) {
        let headerElement = firstChild.outerHTML;
        if(headerElement && headerElement?.indexOf(`http:`) != -1) {
          headerElement = headerElement.replace(
            /http:/g,
            'https:'
          );
          textareaElement.removeChild(firstChild);
          textareaElement.innerHTML = headerElement;
        }
      }
    }
  }
}
